import { Theme } from "common";

export const myStudiesPageStyle = {

  gridWrapper: {
    mt: 1,
  },

  dataGrid: {
    border: "none",
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: Theme.palette.grey[100],
      minHeight: "56px",
      borderBottom: `1px solid ${Theme.palette.grey[300]}`,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: Theme.palette.grey[800],
      fontWeight: 600,
    },
    "& .MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
    },
    "& .MuiDataGrid-row": {
      borderBottom: `1px solid ${Theme.palette.grey[200]}`,
    },
  },

  tablePaper: {
    p: 2,
    borderRadius: 3,
  },

  statusChip: {
    backgroundColor: Theme.palette.success.light,
    color: Theme.palette.success.dark,
    fontWeight: 500,
  },

  menuPaper: {
    width: 220,
    borderRadius: 2,
    p: 1,
  },

  menuIcon: {
    mr: 1,
  },

  protocolCell: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },

  subtitle: {
    fontSize: 13,
    color: Theme.palette.text.secondary,
  },

  statusCardWrapper: {
    container: {
      mt: 1,
    },
  },

  statusCards: {
    gridSize: { xs: 12, sm: 6, md: 4 },

    notYetRecruitingCard: {
      color: {
        bg: "#FFEFB3", text: "#8A6D00",
      },
    },

    recruitingCard: {
      color: {
        bg: "#C6F6D5", text: "#276749",
      },
    },

    finishedRecruitingCard: {
      color: {
        bg: Theme.palette.grey[300],
        text: Theme.palette.grey[700],
      },
    },
  },

  statusColors: {
    NOT_YET_RECRUITING: {
      bg: "#FFEFB3", text: "#8A6D00",
    },
    RECRUITING: {
      bg: "#C6F6D5", text: "#276749",
    },
    FINISHED_RECRUITING: {
      bg: Theme.palette.grey[300],
      text: Theme.palette.grey[700],
    },
    UNRECOGNIZED: {
      bg: Theme.palette.grey[200],
      text: Theme.palette.grey[800],
    },
  },

  ellipsisText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "110px",
    display: "block",
  },

  ellipsisTextWidth: {
    width: "250px",
  },

  fixedHeight: {
    height: "20px",
    fontSize: "0.8rem",
  },
};
